/**
 * @file useCanvasReloadTick.ts
 * @description Счётчик перерисовки канвы конструктора (phase19.16 Р1-6а;
 * вынесено из BuilderCanvas в SB120 этапе 4): сохранилось то, что витрина
 * собирает на сервере (шапка, меню, логотипы — `canvasReloadKey`), —
 * перерисовать с задержкой, чтобы серия правок дала одну перерисовку. Цвета
 * и шрифты приходят живым сообщением и канву не перезагружают.
 */

import { useEffect, useState } from "react";

/** Задержка перерисовки после последней правки. */
export const CANVAS_RELOAD_DELAY_MS = 1200;

/** Номер перерисовки: растёт, когда ключ сменился и устоялся. */
export function useCanvasReloadTick(reloadKey: string): number {
  const [versionTick, setVersionTick] = useState(0);
  const [shownKey, setShownKey] = useState(reloadKey);
  useEffect(() => {
    if (!reloadKey || reloadKey === shownKey) return;
    // Черновик только что загрузился — канва и так открывается с ним.
    if (!shownKey) {
      setShownKey(reloadKey);
      return;
    }
    const t = setTimeout(() => {
      setShownKey(reloadKey);
      setVersionTick((n) => n + 1);
    }, CANVAS_RELOAD_DELAY_MS);
    return () => clearTimeout(t);
  }, [reloadKey, shownKey]);
  return versionTick;
}
